// Paths nunca persistidos como "última rota" nem restaurados após o login
export const NON_RESTORABLE_PATHS = ['/login', '/404', '/500']

export const LISTING_STATUS = [
  { id: 'ls_draft', label: 'Rascunho', value: 'draft' },
  { id: 'ls_available', label: 'Disponível', value: 'available' },
  { id: 'ls_sold', label: 'Vendido', value: 'sold' },
  { id: 'ls_rented', label: 'Alugado', value: 'rented' },
]

export const propertyStatus = [
  { name: 'Ativo', value: 1 },
  { name: 'Inativo', value: 0 },
]

export const exchangeTypes = [
  { name: 'Não', value: 0 },
  { name: 'Sim', value: 1 },
]

export const operationTypes = [
  { name: 'Venda', value: 'S' },
  { name: 'Locação', value: 'R' },
  { name: 'Venda e Locação', value: 'RS' },
]
export const BrazilStates = [
  { id: 1, uf: 'AC', name: 'Acre', timeZone: -5 },
  { id: 2, uf: 'AL', name: 'Alagoas', timeZone: -3 },
  { id: 3, uf: 'AM', name: 'Amazonas', timeZone: -4 },
  { id: 4, uf: 'AP', name: 'Amapá', timeZone: -3 },
  { id: 5, uf: 'BA', name: 'Bahia', timeZone: -3 },
  { id: 6, uf: 'CE', name: 'Ceará', timeZone: -3 },
  { id: 7, uf: 'DF', name: 'Distrito Federal', timeZone: -3 },
  { id: 8, uf: 'ES', name: 'Espírito Santo', timeZone: -3 },
  { id: 9, uf: 'GO', name: 'Goiás', timeZone: -3 },
  { id: 10, uf: 'MA', name: 'Maranhão', timeZone: -3 },
  { id: 11, uf: 'MG', name: 'Minas Gerais', timeZone: -3 },
  { id: 12, uf: 'MS', name: 'Mato Grosso do Sul', timeZone: -4 },
  { id: 13, uf: 'MT', name: 'Mato Grosso', timeZone: -4 },
  { id: 14, uf: 'PA', name: 'Pará', timeZone: -3 },
  { id: 15, uf: 'PB', name: 'Paraíba', timeZone: -3 },
  { id: 16, uf: 'PE', name: 'Pernambuco', timeZone: -3 },
  { id: 17, uf: 'PI', name: 'Piauí', timeZone: -3 },
  { id: 18, uf: 'PR', name: 'Paraná', timeZone: -3 },
  { id: 19, uf: 'RJ', name: 'Rio de Janeiro', timeZone: -3 },
  { id: 20, uf: 'RN', name: 'Rio Grande do Norte', timeZone: -3 },
  { id: 21, uf: 'RO', name: 'Rondônia', timeZone: -4 },
  { id: 22, uf: 'RR', name: 'Roraima', timeZone: -4 },
  { id: 23, uf: 'RS', name: 'Rio Grande do Sul', timeZone: -3 },
  { id: 24, uf: 'SC', name: 'Santa Catarina', timeZone: -3 },
  { id: 25, uf: 'SP', name: 'São Paulo', timeZone: -3 },
  { id: 26, uf: 'SE', name: 'Sergipe', timeZone: -3 },
  { id: 27, uf: 'TO', name: 'Tocantins', timeZone: -3 },
]

export const getStateFullName = (uf) => BrazilStates.find((st) => st.uf === uf).name
export const CnpjMask = [
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '/',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]

export const CpfMask = [
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '.',
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
]
export const CepMask = [/\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]
export const CellPhoneMask = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
export const PhoneMask = [
  '(',
  /\d/,
  /\d/,
  ')',
  ' ',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
  '-',
  /\d/,
  /\d/,
  /\d/,
  /\d/,
]
export const requiredMessage = 'Esse campo é obrigatório.'

export const noItemsViewSlot = 'Não possui items.'

export const BRAZILIAN_MOUNTHS = [
  'Janeiro',
  'Fevereiro',
  'Março',
  'Abril',
  'Maio',
  'Junho',
  'Julho',
  'Agosto',
  'Setembro',
  'Outubro',
  'Novembro',
  'Dezembro',
]

export const BRAZILIAN_WEEK_DAYS = [
  {
    name: 'Domingo',
    short: 'D',
    isWeekend: true,
  },
  {
    name: 'Segunda-feira',
    short: 'S',
  },
  {
    name: 'Terça-feira',
    short: 'T',
  },
  {
    name: 'Quarta-feira',
    short: 'Q',
  },
  {
    name: 'Quinta-feira',
    short: 'Q',
  },
  {
    name: 'Sexta-feita',
    short: 'S',
  },
  {
    name: 'Sábado',
    short: 'S',
    isWeekend: true,
  },
]

export const localeLanguageBr = {
  months: BRAZILIAN_MOUNTHS,
  weekDays: BRAZILIAN_WEEK_DAYS,
  weekStartingIndex: 0,
  getToday(gregorainTodayObject) {
    return gregorainTodayObject
  },
  toNativeDate(date) {
    return new Date(date.year, date.month - 1, date.day)
  },
  getMonthLength(date) {
    return new Date(date.year, date.month, 0).getDate()
  },
  transformDigit(digit) {
    return digit
  },
  nextMonth: 'Next Month',
  previousMonth: 'Previous Month',
  openMonthSelector: 'Open Month Selector',
  openYearSelector: 'Open Year Selector',
  closeMonthSelector: 'Close Month Selector',
  closeYearSelector: 'Close Year Selector',
  from: 'from',
  to: 'to',
  defaultPlaceholder: 'Select...',
  digitSeparator: ',',
  yearLetterSkip: 0,
  isRtl: false,
}

/* PROPERTY MULTISTEP FORM */
// Step one
export const ANNOUNCEMENT_TYPE = [
  { id: 'act_t_property', label: 'Imóvel', value: 'property' },
  { id: 'act_t_enterprise', label: 'Empreendimento', value: 'enterprise' },
]

export const ANNOUNCEMENT_OPERATION = [
  { id: 'act_o_sale', label: 'Venda', value: 'S' },
  { id: 'act_o_rent', label: 'Aluguel', value: 'R' },
  { id: 'act_o_both', label: 'Ambos', value: 'RS' },
]

export const ANNOUNCEMENT_FEATURED = [
  { id: 'act_f_featured', label: 'Destacar', value: 'true' },
  { id: 'act_f_not_featured', label: 'Não destacar', value: 'false' },
]

export const ANNOUNCEMENT_ACTIVE = [
  { id: 'act_a_active', label: 'Ativo', value: 'true' },
  { id: 'act_a_inactive', label: 'Inativo', value: 'false' },
]

export const ANNOUNCEMENT_STATUS = [
  { id: 'act_s_on_site', label: 'Apenas no site', value: 'on_site' },
  { id: 'act_s_on_marketplace', label: 'Apenas no marketplace', value: 'on_marketplace' },
  { id: 'act_s_on_site_marketplace', label: 'Site e marketplace', value: 'on_site_marketplace' },
  { id: 'act_s_processing', label: 'Em andamento', value: 'processing' },
  { id: 'act_s_reserved', label: 'Reservado', value: 'reserved' },
]

// Step two
export const PROPERTY_HAS_ZIP = [
  { id: 'ppt_hz_has', label: 'Possui', value: 'true' },
  { id: 'ppt_hz_has_not', label: 'Não possui', value: 'false' },
]

export const PROPERTY_HAS_NUMBER = [
  { id: 'ppt_hn_has', label: 'Possui', value: 'true' },
  { id: 'ppt_hn_has_not', label: 'Não possui', value: 'false' },
]

export const PROPERTY_HAS_CONDOMINIUM = [
  { id: 'ppt_hc_has', label: 'Possui', value: 'true' },
  { id: 'ppt_hc_not', label: 'Não possui', value: 'false' },
]

export const PROPERTY_USE_CONDOMINIUM = [
  { id: 'ppt_uc_existing', label: 'Usar condomínio registrado', value: 'true' },
  { id: 'ppt_uc_new', label: 'Criar novo condomínio', value: 'false' },
]

// Step three
export const ACCEPT_EXCHANGE = [
  { id: 'ae_yes', label: 'Sim', value: 'true' },
  { id: 'ae_no', label: 'Não', value: 'false' },
]

export const FIXED_AMENITIES_CODES = {
  dorms: 501,
  garage_spaces: 409,
  suites: 521,
  units: 519,
  bathrooms: 505,
}

/**
 * Array de links rápidos para navegação na aplicação.
 *
 * Cada item do array representa um link com as seguintes propriedades:
 *
 * @typedef {Object} QuickLink
 * @property {number} id - Identificador único do link.
 * @property {string} label - Texto exibido para o link.
 * @property {string|null} path - URL relativa usada para navegação interna (roteamento interno da aplicação).
 * @property {string|null} href - URL absoluta ou externa usada para links fora da aplicação.
 *
 * Observações:
 * - Utilize `path` quando o link leva a uma rota interna da aplicação (ex: '/propriedades').
 * - Utilize `href` quando o link leva a um endereço externo ou absoluto (ex: 'https://example.com').
 *
 * @type {QuickLink[]}
 */
export const QUICK_LINKS_DATA = [
  { id: 1, label: 'Lista de propriedades', path: '/propriedades', href: null },
  { id: 2, label: 'Cadastrar corretor', path: '/cadastro/corretor/cadastrar', href: null },
  { id: 3, label: 'Lista de corretores', path: '/cadastro/corretor', href: null },
  { id: 4, label: 'Cadastrar proprietário', path: '/cadastro/proprietario/cadastrar', href: null },
  { id: 5, label: 'Lista de proprietário', path: '/cadastro/proprietario', href: null },
  { id: 6, label: 'Cadastrar captador', path: '/cadastro/captador/cadastrar', href: null },
  { id: 7, label: 'Lista de captador', path: '/cadastro/captador', href: null },
  { id: 8, label: 'Relatórios (Sintético)', path: '/relatorios/sintetico', href: null },
  { id: 9, label: 'Relatórios (Visitas)', path: '/relatorios/visitas', href: null },
  { id: 10, label: 'Relatórios (PageViews)', path: '/relatorios/page-view', href: null },
  { id: 11, label: 'Recebimento de Leads', path: '/formularios', href: null },
]

// ThemeConfig Tabs
export const THEME_CONFIG_MENU = [
  {
    id: 1,
    label: 'Editor de Recursos',
    description: 'Configuração de recursos.',
    path: null,
    component: 'resources',
  },
  {
    id: 2,
    label: 'Editor de Cores',
    description: 'Configuração de cores.',
    path: null,
    component: 'colors',
  },
  {
    id: 2.5,
    label: 'Editor do Popup',
    description: 'Configuração do popup do site.',
    path: null,
    component: 'popup',
  },
  {
    id: 2.6,
    label: 'Editor do Blog',
    description: 'Configuração da página do blog.',
    path: null,
    component: 'blog',
  },
  {
    id: 2.7,
    label: 'Editor do FAQ',
    description: 'Configuração da seção de perguntas frequentes.',
    path: null,
    component: 'faq',
  },
  {
    id: 3,
    label: 'Editor da Página Home',
    description: 'Configuração da home.',
    path: null,
    component: 'home',
  },
  {
    id: 4,
    label: 'Editor da Página Catálogo',
    description: 'Configuração do catálogo.',
    path: null,
    component: 'catalog',
  },
  {
    id: 5,
    label: 'Editor da Página Propriedade',
    description: 'Configuração da propriedade.',
    path: null,
    component: 'property',
  },
  {
    id: 5.5,
    label: 'Editor da Página Empreendimento',
    description: 'Configuração do empreendimento.',
    path: null,
    component: 'enterprise',
  },
  {
    id: 6,
    label: 'Personalizado',
    description: 'Códigos customizados.',
    path: null,
    component: 'global',
  },
  {
    id: 7,
    label: 'Personalização do Spot do Anúncio',
    description: 'HTML do destaque de imóveis',
    component: 'spot',
    path: null,
  },
  {
    id: 8,
    label: 'Configuração Mobile',
    description: 'Personalizações para dispositivos móveis.',
    component: 'mobile',
    path: null,
  },
]

// ThemeConfig Colors Menus
const GLOBAL_MENU = new Map([
  ['primary', { id: 1, label: 'Cor primária' }],
  ['secondary', { id: 2, label: 'Cor secundária' }],
  ['tertiary', { id: 3, label: 'Cor terciária' }],
  ['background', { id: 4, label: 'Cor de fundo da loja' }],
  ['mainTitle', { id: 5, label: 'Cor do título principal' }],
])

const HEADER_MENU = new Map([
  ['background', { id: 1, label: 'Cor de fundo' }],
  ['text', { id: 2, label: 'Cor dos textos' }],
  ['icons', { id: 3, label: 'Cor dos ícones' }],
  ['textHover', { id: 4, label: 'Cor do hover (texto ao passar o mouse)' }],
])

const FOOTER_MENU = new Map([
  ['background', { id: 1, label: 'Cor de fundo' }],
  ['text', { id: 2, label: 'Cor dos textos' }],
  ['textHover', { id: 3, label: 'Cor do hover (texto ao passar o mouse)' }],
  ['copyrightBackground', { id: 4, label: 'Cor de fundo copyright' }],
  ['copyrightText', { id: 5, label: 'Cor do texto do copyright' }],
])

const TAG_MENU = new Map([
  ['saleBackground', { id: 1, label: 'Cor de fundo tag venda' }],
  ['saleText', { id: 2, label: 'Cor de texto tag venda' }],
  ['rentBackground', { id: 3, label: 'Cor de fundo tag aluguel' }],
  ['rentText', { id: 4, label: 'Cor de texto tag aluguel' }],
  ['financingBackground', { id: 5, label: 'Cor de fundo tag financiamento' }],
  ['financingText', { id: 6, label: 'Cor de texto tag financiamento' }],
  ['exclusiveBackground', { id: 7, label: 'Cor de fundo tag exclusivo' }],
  ['exclusiveText', { id: 8, label: 'Cor de texto tag exclusivo' }],
  ['investmentBackground', { id: 9, label: 'Cor de fundo tag baixou o preço' }],
  ['investmentText', { id: 10, label: 'Cor de texto tag baixou o preço' }],
  ['furnishedBackground', { id: 11, label: 'Cor de fundo tag mobiliado' }],
  ['furnishedText', { id: 12, label: 'Cor de texto tag mobiliado' }],
  ['releaseBackground', { id: 13, label: 'Cor de fundo tag lançamento' }],
  ['releaseText', { id: 14, label: 'Cor de texto tag lançamento' }],
  ['newBackground', { id: 15, label: 'Cor de fundo tag anúncio novo' }],
  ['newText', { id: 16, label: 'Cor de tag anúncio novo' }],
])

const BUTTON_MENU = new Map([
  ['background', { id: 1, label: 'Cor de fundo' }],
  ['text', { id: 2, label: 'Cor de texto' }],
])

const BLINKING_BANNER_MENU = new Map([
  ['mainBackground', { id: 1, label: 'Cor de fundo principal' }],
  ['secondaryBackground', { id: 2, label: 'Cor de fundo secundário' }],
  ['mainText', { id: 3, label: 'Cor de texto principal' }],
  ['secondaryText', { id: 4, label: 'Cor de texto secundário' }],
  ['buttonBackground', { id: 5, label: 'Cor de fundo botão' }],
  ['buttonText', { id: 6, label: 'Cor de texto botão' }],
])

export const COLOR_CONFIG_MENU = new Map([
  [
    'global',
    {
      id: 1,
      order: 2,
      label: 'Gerais',
      description: 'Cores Gerais',
      keyName: 'global',
      options: GLOBAL_MENU,
    },
  ],
  [
    'header',
    {
      id: 2,
      order: 1,
      label: 'Cabeçalho',
      description: 'Cores do Cabeçalho',
      keyName: 'header',
      options: HEADER_MENU,
    },
  ],
  [
    'footer',
    {
      id: 3,
      order: 3,
      label: 'Rodapé',
      description: 'Cores do Rodapé',
      keyName: 'footer',
      options: FOOTER_MENU,
    },
  ],
  [
    'tag',
    {
      id: 4,
      order: 4,
      label: 'Tags',
      description: 'Cores das Tags',
      keyName: 'tag',
      options: TAG_MENU,
    },
  ],
  [
    'button',
    {
      id: 5,
      order: 5,
      label: 'Botões',
      description: 'Cores dos Botões',
      keyName: 'button',
      options: BUTTON_MENU,
    },
  ],
  [
    'blinkingBanner',
    {
      id: 6,
      order: 6,
      label: 'Banner Pisca',
      description: 'Cores do Banner Pisca',
      keyName: 'blinkingBanner',
      options: BLINKING_BANNER_MENU,
    },
  ],
])

// ThemeConfig - HomeConfig - Tab

// TODO - preenchimento do objeto.

export const PROPERTY_CONFIG_SUBTABS = [
  {
    key: 'generalOptions',
    id: 1,
    order: 1,
    label: 'Opções Gerais',
    description: 'Configurações gerais da página do imóvel.',
  },
  {
    key: 'gallery',
    id: 2,
    order: 2,
    label: 'Galeria de Fotos',
    description: 'Defina o layout da galeria e a camada intermediária de contato.',
  },
  {
    key: 'characteristics',
    id: 3,
    order: 3,
    label: 'Características',
    description: 'Escolha como as características do imóvel são apresentadas.',
  },
  {
    key: 'contactIncentive',
    id: 4,
    order: 4,
    label: 'Incentivo ao Contato',
    description: 'Configure a seção de perguntas para a imobiliária.',
  },
  {
    key: 'customCss',
    id: 5,
    order: 5,
    label: 'CSS Personalizado',
    description: 'Configure as opções de CSS personalizado',
  },
]

export const HOME_CONFIG_SUBTABS = [
  {
    key: 'header',
    id: 1,
    order: 1,
    label: 'Cabeçalho',
    description: 'Configure as opções para o cabeçalho.',
  },
  {
    key: 'footer',
    id: 1,
    order: 1,
    label: 'Rodapé',
    description: 'Configure as opções para o rodapé.',
  },
  {
    key: 'filter',
    id: 2,
    order: 2,
    label: 'Filtro',
    description: 'Configure as opções de filtro',
  },
  {
    key: 'middleBanner',
    id: 3,
    order: 3,
    label: 'Banner Meio',
    description: 'Configure as opções do banner do meio',
  },
  {
    key: 'showcases',
    id: 4,
    order: 4,
    label: 'Vitrines',
    description: 'Configure as opções das vitrines',
  },
  {
    key: 'bottomBanner',
    id: 5,
    order: 5,
    label: 'Banner Baixo',
    description: 'Configure as opções do banner baixo',
  },
  {
    key: 'linksList',
    id: 6,
    order: 6,
    label: 'Lista de Links',
    description: 'Configure as opções para a lista de links',
  },
  {
    key: 'benefitsBar',
    id: 7,
    order: 7,
    label: 'Régua de Benefícios',
    description: 'Configure as opções para a régua de benefícios',
  },
  {
    key: 'customCss',
    id: 8,
    order: 8,
    label: 'CSS Personalizado',
    description: 'Configure as opções de CSS personalizado',
  },
  {
    key: 'reviews',
    id: 9,
    order: 9,
    label: 'Avaliações',
    description: 'Configure a exibição de avaliações na home',
  },
]

// ThemeConfig - HomeHeaderConfig - Subtab
export const HOME_HEADER_OPTIONS = [
  {
    id: 1,
    value: 'left',
    label: 'Logo à esquerda.',
    default: true,
  },
  {
    id: 2,
    value: 'center',
    label: 'Logo centralizada.',
  },
  {
    id: 3,
    value: 'right',
    label: 'Logo à direita.',
  },
]

// ThemeConfig - HomeFilterConfig - Subtab
export const HOME_FILTER_OPTIONS = [
  {
    id: 1,
    value: 'banner_overlay',
    label: 'Filtro centralizado ao banner.',
    default: true,
  },
  {
    id: 2,
    value: 'banner_bottom',
    label: 'Filtro meio a meio com banner.',
  },
  {
    id: 3,
    value: 'after_banner',
    label: 'Filtro abaixo do banner..',
  },
]

// ThemeConfig - HomeShowcaseConfig - Subtab
export const HOME_SHOWCASE_PROPERTY_TYPE_OPTIONS = [
  {
    id: 'HSPT_1',
    value: 'property',
    label: 'Imóvel',
  },
  {
    id: 'HSPT_2',
    value: 'enterprise',
    label: 'Empreendimento',
  },
]

export const HOME_SHOWCASE_SHOW_OPTIONS = [
  { id: `HSSO_show_yes`, label: 'Sim', value: 'true' },
  { id: `HSSO_show_no`, label: 'Não', value: 'false' },
]

export const HOME_SHOWCASE_DISPLAY_OPTIONS = [
  { id: `HSDO_grid`, label: 'Grade', value: 'grid' },
  { id: `HSDO_list`, label: 'Lista', value: 'list' },
]

export const HOME_SHOWCASE_FEATURED_OPTIONS = [
  { id: `HSFO_feat_yes`, label: 'Sim', value: 'true' },
  { id: `HSFO_feat_no`, label: 'Não', value: 'false' },
]

// ThemeConfig - CatalogConfig - Layout Spots - Subtab
// Sobrescreve o "Layout Padrão" global (resources.property_display_mode) apenas no Catálogo/Busca.
export const CATALOG_LAYOUT_DISPLAY_MODE_OPTIONS = [
  { id: 'CLDM_global', label: 'Usar padrão global', value: '', default: true },
  { id: 'CLDM_grid', label: 'Grade (Grid)', value: 'grid' },
  { id: 'CLDM_list', label: 'Lista (List)', value: 'list' },
]

// ThemeConfig - CatalogConfig - Vitrine do Rodapé - Subtab
// Diferente da Home (grid/list), o catálogo também suporta carrossel.
export const CATALOG_SHOWCASE_DISPLAY_OPTIONS = [
  { id: `CSDO_grid`, label: 'Grade', value: 'grid' },
  { id: `CSDO_list`, label: 'Lista', value: 'list' },
  { id: `CSDO_carousel`, label: 'Carrossel', value: 'carousel' },
]

export const CATALOG_SHOWCASE_PER_PAGE_OPTIONS = [
  { id: 4, name: '4 imóveis' },
  { id: 6, name: '6 imóveis' },
  { id: 8, name: '8 imóveis' },
  { id: 12, name: '12 imóveis' },
  { id: 'custom', name: 'Personalizado...' },
]

// ThemeConfig - HomeBenefitsBar - IDs
export const HOME_BENEFITS_IDS = ['01', '02', '03', '04']

// ThemeConfig - HomeMiddleBanner - Display Modes
export const HOME_MIDDLE_BANNER_DISPLAY_MODES = [
  { id: 'HMBDM_carousel', value: 'carousel', label: 'Carrossel' },
  { id: 'HMBDM_mosaic', value: 'mosaic', label: 'Mosaico' },
]

// ThemeConfig - HomeShowcase - IDs
export const HOME_SHOWCASES_IDS = ['01', '02', '03']

// ThemeConfig - HomeLinksList - Limits
export const MAX_LIST_COLUMNS = 4
export const MAX_LIST_ROWS = 3
export const MAX_LIST = MAX_LIST_COLUMNS * MAX_LIST_ROWS
export const MAX_ITEM = 6

export const MONTHS_LABELS = [
  'Jan',
  'Fev',
  'Mar',
  'Abr',
  'Mai',
  'Jun',
  'Jul',
  'Ago',
  'Set',
  'Out',
  'Nov',
  'Dez',
]
export const EMPTY_MONTHS = new Array(12).fill(0)

// ThemeConfig - MobileConfig - Nav Mobile - Subtab
export const MOBILE_NAV_MODE_OPTIONS = [
  { id: 'MNM_default', label: 'Padrão', value: 'default', default: true },
  { id: 'MNM_app', label: 'Aplicativo', value: 'app' },
]

// ThemeConfig - MobileConfig - Vitrine Mobile - Subtab
export const MOBILE_SHOWCASE_MODE_OPTIONS = [
  { id: 'MSMO_default', label: 'Padrão (igual ao desktop)', value: 'default' },
  { id: 'MSMO_grid_1x1', label: 'Grade 1x1', value: 'grid_1x1' },
  { id: 'MSMO_grid_2x1', label: 'Grade 2x1', value: 'grid_2x1' },
  { id: 'MSMO_carousel', label: 'Carrossel', value: 'carousel' },
]

// ThemeConfig - MobileConfig - Filtro Mobile - Subtab
export const MOBILE_FILTER_MODE_OPTIONS = [
  { id: 'MFM_default', label: 'Padrão', value: 'default', default: true },
  { id: 'MFM_popup', label: 'Popup', value: 'popup' },
  { id: 'MFM_slide_up', label: 'Deslizar para cima', value: 'slide_up' },
]

// ThemeConfig - MobileConfig - Footer Mobile - Subtab
export const MOBILE_FOOTER_MODE_OPTIONS = [
  { id: 'MFTM_open', label: 'Aberto', value: 'open', default: true },
  { id: 'MFTM_accordion', label: 'Sanfona', value: 'accordion' },
]

export const MOBILE_CONFIG_SUBTABS = [
  {
    key: 'navMode',
    id: 1,
    order: 1,
    label: 'Menu do Celular',
    description: 'Escolha como o menu de navegação aparece no celular.',
  },
  {
    key: 'showcaseMode',
    id: 2,
    order: 2,
    label: 'Vitrine',
    description: 'Configure como os imóveis em destaque aparecem no celular.',
  },
  {
    key: 'filterMode',
    id: 3,
    order: 3,
    label: 'Filtros',
    description: 'Configure como os filtros de busca se abrem no celular.',
  },
  {
    key: 'footerMode',
    id: 4,
    order: 4,
    label: 'Rodapé',
    description: 'Configure como o rodapé é exibido no celular.',
  },
  {
    key: 'contactBar',
    id: 5,
    order: 5,
    label: 'Barra de Contato',
    description: 'Ative ou desative a barra de contato fixa no mobile.',
  },
]

export const CATALOG_CONFIG_SUBTABS = [
  {
    key: 'layout',
    id: 1,
    order: 1,
    label: 'Layout Spots',
    description: 'Configure opções de grade/lista e colunas do catálogo.',
  },
  {
    key: 'navigation',
    id: 2,
    order: 2,
    label: 'Navegação',
    description: 'Configure a experiência de rolagem e paginação do catálogo.',
  },
  {
    key: 'filters',
    id: 3,
    order: 3,
    label: 'Filtro',
    description: 'Ative ou desative campos de busca no catálogo.',
  },
  {
    key: 'price',
    id: 4,
    order: 4,
    label: 'Seletor de Preço',
    description: 'Escolha se a faixa de preço é inserida via caixas numéricas ou barra deslizante.',
  },
  {
    key: 'area',
    id: 5,
    order: 5,
    label: 'Seletor de Área',
    description: 'Escolha se a faixa de área (m²) é inserida via caixas numéricas ou barra deslizante.',
  },
  {
    key: 'showcase',
    id: 6,
    order: 6,
    label: 'Vitrine do Rodapé',
    description: 'Configure a vitrine de imóveis recomendados ("Você também pode gostar").',
  },
  {
    key: 'customCss',
    id: 7,
    order: 7,
    label: 'CSS Personalizado',
    description: 'Insira CSS customizado para a página de catálogo.',
  },
]

export const ENTERPRISE_CONFIG_SUBTABS = [
  {
    key: 'generalOptions',
    id: 1,
    order: 1,
    label: 'Opções Gerais',
    description: 'Configurações que valem para os dois layouts da página de empreendimento.',
  },
  {
    key: 'classicDisplay',
    id: 2,
    order: 2,
    mode: 'classic',
    label: 'Exibição',
    description: 'Ative ou desative os elementos exibidos no layout clássico.',
  },
  {
    key: 'classicForm',
    id: 2.1,
    order: 2.1,
    mode: 'classic',
    label: 'Formulário',
    description: 'Configure o formulário de contato da página clássica.',
  },
  {
    key: 'classicMedia',
    id: 2.2,
    order: 2.2,
    mode: 'classic',
    label: 'Mídias',
    description: 'Escolha como a barra de fotos, plantas e vídeos é exibida.',
  },
  {
    key: 'modern',
    id: 3,
    order: 3,
    mode: 'modern',
    label: 'Seções e Ordem',
    description: 'Ative seções e defina a ordem de exibição do layout moderno.',
  },
  {
    key: 'modernHero',
    id: 4,
    order: 4,
    mode: 'modern',
    label: 'Hero',
    description: 'Configure o banner principal do layout moderno.',
  },
  {
    key: 'modernSpecsBar',
    id: 5,
    order: 5,
    mode: 'modern',
    label: 'Barra de Especificações',
    description: 'Escolha quais informações aparecem na barra de especificações.',
  },
  {
    key: 'modernAbout',
    id: 6,
    order: 6,
    mode: 'modern',
    label: 'Sobre',
    description: 'Configure a seção "Sobre" do layout moderno.',
  },
  {
    key: 'modernDifferentials',
    id: 7,
    order: 7,
    mode: 'modern',
    label: 'Diferenciais',
    description: 'Configure a seção de diferenciais do layout moderno.',
  },
  {
    key: 'modernBlueprints',
    id: 8,
    order: 8,
    mode: 'modern',
    label: 'Plantas',
    description: 'Configure a seção de plantas do layout moderno.',
  },
  {
    key: 'modernGallery',
    id: 9,
    order: 9,
    mode: 'modern',
    label: 'Galeria',
    description: 'Configure a galeria de mídias do layout moderno.',
  },
  {
    key: 'modernCta',
    id: 10,
    order: 10,
    mode: 'modern',
    label: 'CTA Formulário',
    description: 'Configure a chamada para ação com formulário.',
  },
  {
    key: 'modernLocation',
    id: 11,
    order: 11,
    mode: 'modern',
    label: 'Localização',
    description: 'Configure a seção de localização do layout moderno.',
  },
]

export const ENTERPRISE_PAGE_MODE_OPTIONS = [
  { id: 'EPM_classic', label: 'Clássica', value: 'classic', default: true },
  { id: 'EPM_modern', label: 'Moderna', value: 'modern' },
]

export const ENTERPRISE_MEDIA_VIEWER_TABS = [
  { key: 'photos', label: 'Fotos' },
  { key: 'construction_photos', label: 'Obras' },
  { key: 'blueprints', label: 'Plantas' },
  { key: 'videos', label: 'Vídeos' },
  { key: 'construction_videos', label: 'Obras Vídeos' },
  { key: 'videos_360', label: '360°' },
  { key: 'map', label: 'Mapa' },
]

export const ENTERPRISE_MOBILE_CTA_ACTION_OPTIONS = [
  { id: 'open_whatsapp', name: 'Abrir WhatsApp' },
  { id: 'scroll_to_form', name: 'Rolar até o formulário' },
  { id: 'open_modal', name: 'Abrir modal de contato' },
]

export const ENTERPRISE_MOBILE_CTA_ICON_OPTIONS = [
  { id: '', name: 'Sem ícone' },
  { id: 'whatsapp', name: 'WhatsApp' },
  { id: 'headset', name: 'Fale Conosco' },
  { id: 'mail', name: 'Mensagem' },
  { id: 'house-plus', name: 'Conhecer o Imóvel' },
  { id: 'papers', name: 'Formulário' },
]

export const ENTERPRISE_CLASSIC_MEDIA_FORMAT_OPTIONS = [
  { id: 'ECMF_tabs', label: 'Abas horizontais', value: 'horizontal_tabs', default: true },
  { id: 'ECMF_badges', label: 'Badges sobrepostos', value: 'overlay_badges' },
]

export const ENTERPRISE_MODERN_SECTIONS = [
  { key: 'about', label: 'Sobre' },
  { key: 'differentials', label: 'Diferenciais' },
  { key: 'blueprints', label: 'Plantas' },
  { key: 'gallery', label: 'Galeria' },
  { key: 'cta', label: 'CTA Formulário' },
  { key: 'location', label: 'Localização' },
]

export const ENTERPRISE_HERO_CTA_ACTION_OPTIONS = [
  { id: 'scroll_to_section', name: 'Rolar até uma seção da página' },
  { id: 'open_whatsapp', name: 'Abrir WhatsApp' },
]

export const ENTERPRISE_HERO_SCROLL_TARGET_OPTIONS = ENTERPRISE_MODERN_SECTIONS.map(
  ({ key, label }) => ({ id: key, name: label })
)

export const ENTERPRISE_MODERN_SECTIONS_DEFAULT_ORDER = ENTERPRISE_MODERN_SECTIONS.map(
  ({ key }) => key
)

export const ENTERPRISE_SPECS_ITEMS = [
  { key: 'usable_area', label: 'Área útil' },
  { key: 'bedrooms', label: 'Dormitórios' },
  { key: 'suites', label: 'Suítes' },
  { key: 'garage_spaces', label: 'Vagas' },
  { key: 'delivery_date', label: 'Data de entrega' },
]

export const ENTERPRISE_SPECS_ITEMS_LIMIT = 4

export const ENTERPRISE_SPECS_AREA_FORMAT_OPTIONS = [
  { id: 'range', name: 'Faixa (ex: 45m² a 90m²)' },
  { id: 'starting_from', name: 'A partir de (ex: a partir de 45m²)' },
  { id: 'exact', name: 'Exato (ex: 45m²)' },
]

export const ENTERPRISE_GALLERY_PAGE_SIZE_OPTIONS = [
  { id: '4', name: '4 por página' },
  { id: '6', name: '6 por página' },
  { id: '8', name: '8 por página' },
  { id: '12', name: '12 por página' },
]

export const ENTERPRISE_GALLERY_TABS = [
  { key: 'all', label: 'Todas' },
  { key: 'photos', label: 'Fotos' },
  { key: 'blueprints', label: 'Plantas' },
  { key: 'building_progress', label: 'Obras / Progresso' },
]

